module.exports = __webpack_public_path__ + "static/elizabeth-315dbc2f3b320dae1b68f5a949c520fc.jpeg";